import { Button } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { WatchlistsDropdown } from '~/components/watchlist/watchlist-dropdown/WatchlistsDropdown';
import { useWatchlistActions } from '~/hooks/use-watchlist-actions/useWatchlistActions';
import { useApp, ViewMode } from '~/stores/use-app/useApp';
import { useWatchlist } from '~/stores/use-watchlist/useWatchlist';
import { Watchlist } from '~/stores/use-watchlist/watchlist-types';

import * as S from './AssetsHeader.styles';

export interface Asset {
  ticker: string;
  price: string;
  daily_change_price: number;
  daily_change_percentage: number;
  pe: string;
  macd: string;
  rsi: string;
}

export interface AssetsHeaderProps {
  setIsSummaryOpen: (open: boolean) => void;
  isSummaryOpen: boolean;
  list: Watchlist;
}

export const AssetsHeader = ({
  setIsSummaryOpen,
  isSummaryOpen,
  list,
}: AssetsHeaderProps) => {
  const { t } = useTranslation(['widget', 'watchlistManager']);
  const { navigateToWatchlist } = useWatchlistActions();
  const setActiveListId = useWatchlist(state => state.setActiveListId);
  const isGrid = useApp(state => state.dashboardViewMode === ViewMode.Grid);

  const onSetActiveListId = (id: string) => {
    setActiveListId(id);
  };

  return (
    <>
      <S.Header $isSummary={isSummaryOpen}>
        <S.DropdownWrapper $isGrid={isGrid}>
          <WatchlistsDropdown list={list} setActiveListId={onSetActiveListId} />
        </S.DropdownWrapper>

        {!isSummaryOpen && (
          <S.ActionButtons data-testid="watchlist-header">
            <Button
              data-testid="summarize-button"
              iconName="Summarise"
              variant="tertiary"
              size="small"
              label={t('widget:watchlist.summarize')}
              onClick={() => setIsSummaryOpen(true)}
              disabled={!list}
            />
            <Button
              iconName="Expand"
              variant="tertiary"
              size="small"
              onClick={() => navigateToWatchlist(list?.id)}
            />
          </S.ActionButtons>
        )}

        {isSummaryOpen && (
          <S.WatchlistSummaryActions
            $isGrid={isGrid}
            data-testid="watchlist-header-summary"
          >
            <Button
              variant="empty"
              size="small"
              label={t('watchlistManager:closeSummary')}
              onClick={() => setIsSummaryOpen(false)}
            />
          </S.WatchlistSummaryActions>
        )}
      </S.Header>
    </>
  );
};
